import React, { Component } from 'react';
import { connect } from 'react-redux';
import { doLogout, updateIsUserLoggedIn } from './UserInfo.actions';
import { clearUserInfo } from '../../state/user/User.actions';
import { withRouter } from '../../utils/NavigationWrapper';
import { withMsal } from '@azure/msal-react';
import { msalConfig } from '../../constants/authConfig';
import UserInfo from './UserInfo';
import Constants from '../../constants/Constants';

class UserInfoContainer extends Component {
  constructor() {
    super();
    this._onClickChangePasswordOption = this._onClickChangePasswordOption.bind(this);
    this._onClickLogOut = this._onClickLogOut.bind(this);
  }

  render() {
    const { user } = this.props;

    if (!user) {
      return null;
    }

    return (
      <UserInfo
        onClickChangePasswordOption={this._onClickChangePasswordOption}
        onClickLogoutOption={this._onClickLogOut}
        username={this.props.user.Username}
        role={this.props.user.Role}
        avatarUrl={this.props.user.avatar_url}
      />
    );
  }

  _onClickChangePasswordOption() {
    window.location.href = Constants.ADB2C_RESET_PASSWORD_LINK;
  }

  _onClickLogOut() {
    updateIsUserLoggedIn(false).then((res) => {
      return this.props._doLogout();
    });
  }
}

const mapStateToProps = (state) => ({
  user: state.user.User,
});

const mapDispatchToProps = (dispatch, props) => ({
  _doLogout: () => {
    dispatch(clearUserInfo());
    localStorage.clear();
    return props.msalContext.instance.logoutRedirect({
      postLogoutRedirectUri: msalConfig.auth.redirectUri,
      mainWindowRedirectUri: msalConfig.auth.redirectUri,
    });
  },
});

export default withMsal(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UserInfoContainer))
);
